import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.starts-with.js";
export default (function () {
  var route = useRoute();
  var isFaqPage = computed(function () {
    var _route$name;
    return !!(route !== null && route !== void 0 && (_route$name = route.name) !== null && _route$name !== void 0 && _route$name.startsWith('legacy-FAQ-Index'));
  });
  return {
    isFaqPage: isFaqPage
  };
});